module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_umeda-4a9f7b343d9ae30d0096bf356db1d6be.jpg";